/* Shopify Chat controls -> Clarity and Shopify Customer Events.
 * Never read iframe content, messages, customer identity, or event.detail.
 * The launcher is public; the rest of the widget remains masked in Clarity.
 */
(function () {
  'use strict';
  if (window.repubblicaChatAnalyticsLoaded) return;
  window.repubblicaChatAnalyticsLoaded = true;

  var script = document.currentScript;
  var pageType = script ? script.getAttribute('data-page-type') || 'other' : 'other';
  var environment = script && script.getAttribute('data-theme-role') === 'main' ? 'live' : 'preview';
  var hosts = new WeakSet();
  var roots = new WeakSet();
  var buttons = new WeakSet();
  var launchers = new Set();
  var viewed = false;
  var clarityQueue = [];
  var retryTimer = null;
  var retryCount = 0;
  var privacyLoading = false;
  var privacyFailed = false;

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && privacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function flushClarity() {
    if (!analyticsAllowed()) { clarityQueue = []; return; }
    if (typeof window.clarity !== 'function') return;
    while (clarityQueue.length) {
      var item = clarityQueue.shift();
      if (Date.now() - item.at > 30000) continue;
      try {
        window.clarity('set', 'chat_provider', 'shopify_inbox');
        window.clarity('set', 'chat_environment', environment);
        window.clarity('set', 'chat_page_type', pageType);
        if (item.name === 'chat_open') window.clarity('set', 'chat_used', 'true');
        window.clarity('event', item.name);
      } catch (error) { /* Tracking must never break the chat. */ }
    }
  }

  function publish(name, source) {
    if (!analyticsAllowed()) return false;
    var data = {
      chat_provider: 'shopify_inbox',
      chat_environment: environment,
      chat_placement: 'floating_button',
      chat_source: source,
      page_type: pageType
    };
    if (window.RPExperience) data = window.RPExperience.enrich(data);
    clarityQueue.push({ name: name, at: Date.now() });
    if (clarityQueue.length > 20) clarityQueue.shift();
    flushClarity();
    if (clarityQueue.length) scheduleRetry();
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        var result = analytics.publish('repubblica:' + name, data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('repubblica:chat', {
      detail: Object.assign({ event_name: name }, data)
    }));
    return true;
  }

  function visible(button, host) {
    if (!button.isConnected || host.hasAttribute('open') || document.visibilityState === 'hidden') return false;
    if (document.documentElement.classList.contains('RPChatDrawerOpen')) return false;
    var style = window.getComputedStyle(button);
    var rect = button.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 &&
      rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function checkViews() {
    if (viewed) return;
    launchers.forEach(function (entry) {
      if (!entry.button.isConnected) { launchers.delete(entry); return; }
      if (!viewed && visible(entry.button, entry.host)) viewed = publish('chat_button_view', 'launcher');
    });
  }

  var intersection = 'IntersectionObserver' in window ? new IntersectionObserver(checkViews) : null;

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function enhanceRoot(root, host, state) {
    // Only inspect public shell controls; never descend into an iframe.
    root.querySelectorAll('button[part~="activator"]').forEach(function (button) {
      setAttribute(button, 'data-clarity-unmask', 'true');
      setAttribute(button, 'data-analytics-click-target', 'chat_launcher');
      setAttribute(button, 'id', 'repubblica-chat-launcher');
      setAttribute(button, 'aria-label', 'Open chat with Repubblica');
      setAttribute(button, 'title', 'Chat with Repubblica');
      if (buttons.has(button)) return;
      buttons.add(button);
      launchers.add({ button: button, host: host });
      if (intersection) intersection.observe(button);
      button.addEventListener('click', function () {
        if (host.hasAttribute('open')) return;
        // A click proves visibility even if it precedes the observer callback.
        if (!viewed) viewed = publish('chat_button_view', 'launcher');
        state.lastClick = Date.now();
        publish('chat_button_click', 'launcher');
      }, true);
    });
    root.querySelectorAll('[part~="dialog"]').forEach(function (panel) {
      setAttribute(panel, 'data-clarity-mask', 'true');
    });
    root.querySelectorAll('shopify-agent-runtime').forEach(function (runtime) {
      if (runtime.shadowRoot) observeRoot(runtime.shadowRoot, host, state);
    });
    checkViews();
  }

  function observeRoot(root, host, state) {
    if (roots.has(root)) { enhanceRoot(root, host, state); return; }
    roots.add(root);
    new MutationObserver(function () { enhanceRoot(root, host, state); }).observe(root, {
      childList: true, subtree: true
    });
    enhanceRoot(root, host, state);
  }

  function bindHost(host) {
    if (hosts.has(host)) return;
    hosts.add(host);
    if (!host.id) host.id = 'repubblica-chat';
    setAttribute(host, 'data-clarity-mask', 'true');
    var state = { open: host.hasAttribute('open'), lastClick: 0 };
    // A restored panel is not a fresh button click, and is not counted as one.
    new MutationObserver(function () {
      var open = host.hasAttribute('open');
      if (open === state.open) return;
      state.open = open;
      publish(open ? 'chat_open' : 'chat_close',
        open && Date.now() - state.lastClick < 3000 ? 'launcher' : 'widget');
      checkViews();
    }).observe(host, { attributes: true, attributeFilter: ['open'] });
    function bindShell() {
      if (host.shadowRoot) observeRoot(host.shadowRoot, host, state);
      checkViews();
    }
    bindShell();
    if (window.customElements) {
      window.customElements.whenDefined('shopify-chat').then(bindShell);
      window.customElements.whenDefined('shopify-agent-runtime').then(bindShell);
    }
  }

  function discover() { document.querySelectorAll('shopify-chat').forEach(bindHost); }

  function loadPrivacy() {
    if (privacyLoading || privacyFailed || (window.Shopify && window.Shopify.customerPrivacy)) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        privacyLoading = false;
        privacyFailed = !!error;
        if (!error) { checkViews(); flushClarity(); }
      });
    } catch (error) { privacyLoading = false; privacyFailed = true; }
  }

  function scheduleRetry() {
    if (retryTimer !== null || retryCount >= 30) return;
    retryTimer = window.setTimeout(function () {
      retryTimer = null;
      retryCount += 1;
      loadPrivacy();
      checkViews();
      flushClarity();
      if (clarityQueue.length || (!privacyFailed && !(window.Shopify && window.Shopify.customerPrivacy))) scheduleRetry();
    }, 1000);
  }

  function init() {
    discover();
    new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        return Array.prototype.some.call(change.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('shopify-chat') || node.querySelector('shopify-chat'));
        });
      })) discover();
    }).observe(document.body, { childList: true, subtree: true });
    new MutationObserver(checkViews).observe(document.documentElement, {
      attributes: true, attributeFilter: ['class']
    });
    document.addEventListener('visitorConsentCollected', function () {
      // Do not replay actions performed before consent, or after it is revoked.
      clarityQueue = [];
      checkViews();
    });
    document.addEventListener('visibilitychange', checkViews);
    window.addEventListener('resize', checkViews, { passive: true });
    window.addEventListener('pageshow', checkViews);
    loadPrivacy();
    scheduleRetry();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
